import { render, staticRenderFns } from "./pdd.vue?vue&type=template&id=c6e98462&scoped=true"
import script from "./pdd.vue?vue&type=script&lang=js"
export * from "./pdd.vue?vue&type=script&lang=js"
import style0 from "./pdd.vue?vue&type=style&index=0&id=c6e98462&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6e98462",
  null
  
)

export default component.exports